import { render, staticRenderFns } from "./AliTaobaoDbTool.vue?vue&type=template&id=39c80bbe&scoped=true&"
import script from "./AliTaobaoDbTool.vue?vue&type=script&lang=js&"
export * from "./AliTaobaoDbTool.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39c80bbe",
  null
  
)

export default component.exports